import { render, staticRenderFns } from "./StockGroupForm.vue?vue&type=template&id=c1ed400e&"
import script from "./StockGroupForm.vue?vue&type=script&lang=js&"
export * from "./StockGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports